<template>
  <div class="interface">
    <div class="title">
      <img
        class="title_background"
        src="../../../static/ningbo/ningbo_log/pay_background.png"
        alt=""
      />
      <div class="title_top">
        <img
          class="title_top_log"
          src="../../../static/ningbo/ningbo_log/log_pay.png"
          alt=""
        />
        <div class="title_top_text">等待申请人付款</div>
      </div>
      <div class="text">
        您的图片已提交，请在24小时内完成支付。超时订单将自动取消。
      </div>
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 信息展示 -->
        <div class="infodisplay">
          <div class="infodisplay_goods">
            <div class="infodisplay_name">商品信息</div>
            <div class="infodisplay_money">
              <div class="infodisplay_money01">版面定制服务费：</div>
              <div class="infodisplay_money02">¥{{ price_nb / 100 }}</div>
            </div>
          </div>
          <hr />
          <div class="coupon">
            <div class="coupon_name">优惠券码</div>
            <!-- <input
              type="text"
              class="coupon_input"
              placeholder="请输入优惠券码"
              v-model="voucherCode"
            /> -->
            <div>
              <b-form-input
                v-model="voucherCode"
                placeholder="请输入优惠券码"
                :state="voucherCodeError ? false : null"
                class="coupon_input"
              ></b-form-input>
              <b-form-invalid-feedback
                class="coupon_input_"
                v-if="voucherCodeError"
                >{{ voucherCodeErrorMessage }}</b-form-invalid-feedback
              >
            </div>
          </div>
          <hr />
          <div>
            <div class="infodisplay_goods">
              <div class="infodisplay_name">订单运费</div>
              <div class="infodisplay_money">
                <div class="infodisplay_money01">应付运费：</div>
                <div class="infodisplay_money02">
                  ¥{{ freightCharges / 100 }}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <div class="infodisplay_goods">
              <div class="infodisplay_name">服务费+订单运费</div>
              <div class="infodisplay_money">
                <div class="infodisplay_money01">应付总额：</div>
                <div class="infodisplay_money02">
                  <!-- ¥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }} -->
                  ¥{{ price_NB / 100 }}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="order_info">
            <div class="order_name">订单信息</div>
            <div class="order_item">
              <!-- <div class="order_item01">
                订单编号：{{ orderInfoObj == null ? "" : orderInfoObj.orderNo }}
              </div> -->
              <div class="order_item01">
                订单编号：{{ orderInfoObj == null ? "" : orderInfoObj.orderNo }}
              </div>
              <!-- <div class="order_item01">
                下单时间：{{
                  orderInfoObj == null ? "" : orderInfoObj.orderDateTime
                }}
              </div> -->
              <div class="order_item01">
                下单时间：{{
                  orderInfoObj == null ? "" : orderInfoObj.orderDateTime
                }}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <!-- 温馨提示 -->
        <div class="warm_reminder">
          <div class="warm_reminder01">
            <div class="warm_reminder_name">温馨提示：</div>
            <div class="warm_reminder_logo">!</div>
          </div>
          <div class="warm_reminder02">
            <div class="item">{{ hint.hint_item01 }}</div>
            <div class="item">{{ hint.hint_item02 }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="showCancelConfirm" @click="showCancelConfirm()">
          取消订单
        </div>
        <div class="toPay" @click="wxH5Pay()">微信支付</div>
      </div>
    </div>
    <!-- loading toast -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">下单中</p>
      </div>
    </div>

    <div v-show="showToast">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{ toastMsg }}</p>
      </div>
    </div>

    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <b-modal
      ref="model_cancel_confirm"
      title="提示"
      @ok="handleCancelOrder"
      ok-title="取消"
      cancel-title="暂不取消"
      centered
    >
      <b-row>
        <b-col cols="10" class="mx-auto"> 确认取消订单？ </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ok-only
      ref="model_cancel_result"
      title="提示"
      @ok="handeCancelResult"
      ok-title="确定"
      centered
    >
      {{ cancelResult }}
    </b-modal>
    <b-modal
      ref="model_pay_result"
      title="提示"
      ok-title="已完成支付"
      @ok="doneWxH5Pay()"
      cancel-title="支付遇到问题，重新支付"
      @cancel="reWxH5Pay()"
      no-close-on-esc
      centered
      :hide-header-close="true"
    >
      <p>请确认微信支付是否已完成?</p>
    </b-modal>
    <b-modal
      ref="model_back_ios_app"
      title="提示"
      ok-title="确定"
      @ok="backToIosApp()"
      no-close-on-esc
      ok-only
      centered
      :hide-header-close="true"
    >
      <p>请返回手机银行App,确认支付结果。</p>
    </b-modal>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("@/common/config.js");
export default {
  name: "orderPay_ningbo",
  data() {
    return {
      url: "",
      price_nb: "",
      price_NB: "",
      freightCharges: "1000",
      orderInfoObj: null,
      appid: "",
      code: "",
      thumbnailSrc: "",
      loading: false,
      showToast: false,
      toastMsg: "",
      targetUrl: "",
      voucherCode: "",
      errorMsg: "",
      faceValue: "",
      practicalAmt: "",
      originalAmt: "",
      hint: {
        hint_info:
          "订单状态：等待申请人付款。您的图片已提交，请在24小时内完成支付，超时订单将自动取消。",
        hint_item01: "1.支付成功后，将无法更改以上卡片定制信息",
        hint_item02: "2.我们将在15个工作日左右为您寄送卡片，请注意查收",
      },
      cancelResult: "",
      voucherCodeError: false,
      voucherCodeErrorMessage: "请输入正确的优惠券码",
    };
  },
  watch: {
    voucherCode: function (newval, oldval) {
      this.validatevoucherCode(newval);
    },
  },
  methods: {
    validatevoucherCode(voucherCode) {
      const voucherCodeRegex = /^[A-Za-z0-9]+$/;
      if (!voucherCodeRegex.test(voucherCode)) {
        this.voucherCodeError = true;
      } else {
        this.voucherCodeError = false;
      }
    },
    showCancelConfirm: function () {
      this.$refs["model_cancel_confirm"].show();
    },
    handleCancelOrder: function () {
      this.cancelOrder();
    },
    showCancelResult: function () {
      this.$refs["model_cancel_result"].show();
    },
    handeCancelResult: function () {
      this.$router.push({
        name: "home_ningbo",
      });
    },
    cancelOrder: function () {
      var that = this;
      axios
        .get(config.config_nb.refund, {
          params: {
            orderNo: this.orderInfoObj.orderNo,
          },
        })
        .then(function (response) {
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
            // setTimeout(function() {
            //   that.$router.go(-3)
            // })
          } else {
            that.cancelResult = data.message;
            // that.$bvToast.toast(data.message, {
            //   title: '提示',
            //   autoHideDelay: 3000,
            //   toaster: 'b-toaster-bottom-center'
            // })
          }
          that.showCancelResult();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    toOrderResult: function () {
      this.$router.replace({
        name: "orderResult_ningbo",
        params: {
          orderNo: this.orderInfoObj.orderNo,
        },
      });
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    /*
    @param voucherValue,优惠券面额
    @orderPrice 订单金额
     */
    caculatePriceWidthVoucher(voucherValue, orderPrice) {
      let price = orderPrice - voucherValue;
      if (price < 0) {
        return 0;
      }
      return price;
    },
    queryVoucher: function () {
      //检查优惠券
      var that = this;
      axios
        .get(config.config_nb.queryVoucher, {
          params: {
            bankCode: this.orderInfoObj.bankCode,
            voucherCode: this.voucherCode,
            cardTypeId: this.orderInfoObj.cardTypeId,
          },
        })
        .then(function (response) {
          console.log(response);
          var result = response.data;
          //{code: 103, message: "未找到对应的优惠券信息", faceValue: 0, practicalAmt: 0, originalAmt: 0}
          if (result.code == 0) {
            that.faceValue = result.faceValue;
            // that.practicalAmt = result.practicalAmt;
            // that.originalAmt = result.originalAmt;
            let price = that.caculatePriceWidthVoucher(
              result.faceValue,
              this.price_NB
            );
            that.unifyOrderWithVoucher(price);
          } else {
            that.errorMsg = result.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
    wxH5Pay() {
      this.initH5PayAction();
    },
    //H5支付方式初始化获取appid
    initH5PayAction() {
      var that = this;
      var formData = new FormData();
      formData.append("bankCode", "default");
      formData.append("type", "1");
      axios({
        method: "post",
        url: config.config_nb.initH5Pay,
        data: formData,
      })
        .then((res) => {
          let result = res.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          that.appid = result.data.appid;
          console.log("appid--->", that.appid);
          that.wxH5PayAction();
        })
        .catch((error) => {
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    wxH5PayAction() {
      this.unifyOrder();
    },
    // H5支付
    starToPay(payargs) {
      this.setWxH5payState();
      //{"code":0,"msg":"成功","data":{"timeStamp":"1706582624","h5url":"https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx30104344445466d0fea7a575e018120000&package=4145400295","package":"prepay_id=wx30104344445466d0fea7a575e018120000","appId":"","sign":"","signType":"MD5","nonceStr":""}}
      if (this.isIOS()) {
        let url = window.location.href;
        // let paySuccessUrl = "https://pbank.hsbank.cc/app/";
        let paySuccessUrl = url;
        let h5url = `${payargs.h5url}&redirect_url=${encodeURIComponent(
          paySuccessUrl
        )}`;
        // let h5url = `${payargs.h5url}&redirect_url=${encodeURIComponent(url)}`;
        window.location.href = h5url;
      } else {
        let h5url = payargs.h5url;
        window.location.href = h5url;
      }
    },
    // ios
    isIOS() {
      let equipmentType = "";
      let agent = navigator.userAgent.toLowerCase();
      let iphone = agent.indexOf("iphone");
      let ipad = agent.indexOf("ipad");
      if (iphone != -1 || ipad != -1) {
        equipmentType = "ios";
      }
      return equipmentType == "ios";
    },
    setWxH5payState() {
      sessionStorage.setItem("wxh5pay", "paying");
    },
    getWxH5payState() {
      return sessionStorage.getItem("wxh5pay");
    },
    clearWxH5payState() {
      sessionStorage.removeItem("wxh5pay");
    },
    reWxH5Pay() {
      this.clearWxH5payState();
      this.wxH5Pay();
    },
    doneWxH5Pay() {
      this.clearWxH5payState();
      this.toOrderResult();
    },
    notifyPayResult: function (result) {
      //通知后台，订单支付成功
      //result "SUCCESS" 成功, "FAIL" 失败
      let payResult = {
        orderId: this.orderInfoObj.orderNo,
        ordersStats: result,
      };
      axios
        .post(config.config_nb.appNotify, payResult)
        .then(function (response) {
          console.log(response);
          //alert(JSON.stringify(response))
        })
        .catch(function (error) {
          console.log(error);
          //alert(JSON.stringify(error))
        });
    },
    adaptIosUrl: function () {
      var url = window.location.href.split("#")[0];
      if (url.indexOf("?") != -1) {
        this.targetUrl = url.split("?")[0];
      } else {
        this.targetUrl = url;
      }
    },

    unifyOrderWithVoucher: function (discountedPrice) {
      var that = this;
      var openid = sessionStorage.getItem("openid");
      if (openid == undefined) {
        return;
      }
      // var myObj = {
      //   hbTradeType: 1,
      //   openId: openid,
      //   orderNo: this.orderInfoObj.orderNo,
      //   totalFee: discountedPrice,
      //   pay_source: this.orderInfoObj.projectName,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   // practicalAmt: this.practicalAmt,
      //   orderAmt: this.orderInfoObj.price,
      //   appId: this.appid,
      //   payMethod: "wechat",
      // };

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.price_NB,
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price,
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_nb.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              if (that.orderInfoObj.price == 0) {
                //0元，无需支付，直接跳转到订单结果页面
                that.toOrderResult();
              } else {
                that.starToPay(payargs);
              }
            }
          } else {
            that.errorMsg = "unifiedOrder：" + data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    unifyOrder: function () {
      var that = this;
      var myObj = {
        hbTradeType: 3, //H5支付
        openid: "",
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.price_NB, //支付金额
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.amountPaid, //订单金额
        appid: this.appid,
      };
      // console.log(JSON.stringify(myObj));
      console.log("myObj--->", myObj);
      that.showLoading();
      axios
        .post(config.config_nb.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log("response--->", response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              that.starToPay(payargs);
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },

    showIosBackTip() {
      this.$refs["model_back_ios_app"].show();
    },
    showPayResult() {
      this.$refs["model_pay_result"].show();
    },
    backToIosApp() {
      // 测试案例
      let nbbankApp = "";
      window.location.href = nbbankApp;
    },
  },
  mounted: function () {
    console.log("isProductMode", config.config_nb.isProductMode);
    if (!config.config_nb.isProductMode) {
      this.url = "https://ts.hengbao.net.cn/#/ningbo/orderResult_ningbo";
      this.price_NB = 2;
      console.log(" this.url", this.url);
    } else {
      this.price_NB = 6000;
      this.url = "https://cp.hengbao.net.cn/#/ningbo/orderResult_ningbo";
      console.log(" this.url", this.url);
    }

    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }
    this.price_nb = localStorage.getItem("price_nb");
    console.log("price_nb", this.price_nb);
    console.log("this.freightCharges;", this.freightCharges);
    // this.price_NB = this.price_nb + this.freightCharges;
    // console.log(" this.price_NB", this.price_NB);
    //关于支付后跳转问题
    let wxH5state = this.getWxH5payState(); //wxh5pay=paying
    console.log("wxH5state->", wxH5state);
    if (wxH5state == "paying") {
      //wxh5支付返回后，页面重新加载
      this.showPayResult();
    } else {
      //ios微信h5支付，支付或未支付返回时，跳转回app兼容方案
      // console.log("orderInfoObj is null", this.orderInfoObj == null);
      console.log("this.isIOS()", this.isIOS());
      if (this.isIOS() && this.orderInfoObj == null) {
        // this.showIosBackTip();
      }
    }
  },
  destroyed: function () {
    this.clearWxH5payState();
  },
};
</script>

<style scoped>
.title {
  width: 100%;
}
.title_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;
  position: absolute;
  top: 2rem;
  left: 20%;
}
.title_top_log {
  width: 2rem;
  height: 2rem;
}
.title_top_text {
  font-size: 1.2rem;
  font-weight: 700;
}
.title_background {
  width: 100%;
}
.text {
  width: 70%;
  font-size: 0.8rem;
  color: #92969b;
  position: absolute;
  top: 4rem;
  left: 15%;
  text-align: center;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  width: 100%;
  position: absolute;
  top: 7rem;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0.6rem;
}
/* .header {
  background-color: aqua;
  height: 3rem;
  padding-top: 1.8rem;
} */
.header_hint {
  width: 100%;
  background-color: #f9ecd0;
  color: #a66e36;
  font-weight: 500;
  font-size: 0.8rem;
  padding: 1.8rem 1rem 0;
}
.infodisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infodisplay_goods {
  width: 100%;
  height: 3.6rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.infodisplay_name {
  font-size: 1rem;
  font-weight: 700;
}
.infodisplay_money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.infodisplay_money01 {
  font-size: 0.8rem;
  font-weight: 500;
}
.infodisplay_money02 {
  font-size: 0.8rem;
  font-weight: 700;
}
.coupon {
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.coupon_name {
  font-size: 1rem;
  font-weight: 700;
}
.coupon_input {
  width: 10rem;
  height: 2rem;
  border: white solid 0;
}
.order_info {
  width: 100%;
  height: 3.6rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.order_name {
  font-size: 1rem;
  font-weight: 700;
}
.order_item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.order_item01 {
  font-size: 0.6rem;
}
.freightCharges_arr {
  margin-left: 14rem;
}
.freightCharges {
  font-size: 0.8rem;
  color: red;
}
.warm_reminder {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 1rem;
}
.warm_reminder01 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start; /* 显式声明靠左 */
}
.warm_reminder_name {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
  margin-right: 1rem;
}
.warm_reminder_logo {
  width: 1rem;
  height: 1rem;
  border: #dcb884 solid 1px;
  color: white;
  border-radius: 50%;
  text-align: center;
  background-color: #dcb884;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 900;
}
.warm_reminder02 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  padding-bottom: 0.2rem;
}
.main {
  /* background-color: yellow;
  height: 3rem; */
  width: 100%;
}
.footer {
  /* background-color: blue; */
  /* height: 3rem; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.toPay {
  width: 50%;
  height: 2.8rem;
  border-radius: 1.4rem;
  background: linear-gradient(to right, #093695, #0d1632);
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 auto;
  /* margin-top: 3rem; */
}
.showCancelConfirm {
  width: 40%;
  height: 2.8rem;
  border-radius: 1.4rem;
  background-color: #ffffff;
  color: #093695;
  border: 1px solid #093695;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 auto;
  /* margin-top: 1rem; */
}
</style>



// WEBPACK FOOTER //
// src/components/ningboBus/OrderPay_app_ningbo.vue